var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-layout',{directives:[{name:"resize",rawName:"v-resize",value:(_vm.onResize),expression:"onResize"}],attrs:{"row":""}},[_c('div',{style:(_vm.mapDimenstions),attrs:{"id":"map"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }